export default "__VITE_ASSET__s75w6Mbp__"